"use client";

import { BookOpen } from "lucide-react";

import { CourseCard } from "./course-card";
import type { CourseCatalogItem } from "@/types";

interface CoursesCatalogProps {
  courses: CourseCatalogItem[];
}

export function CoursesCatalog({ courses }: CoursesCatalogProps) {
  const hasCourses = courses.length > 0;

  return (
    <div className="bg-gradient-to-b from-secondary/30 via-background to-background">
      <section className="relative overflow-hidden border-b border-border/50 bg-gradient-to-br from-primary/5 via-background to-secondary/20 py-20">
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <div className="absolute -right-20 top-0 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
          <div className="absolute -left-20 bottom-0 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
        </div>
        <div className="container space-y-6">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-primary backdrop-blur-sm">
            <BookOpen className="h-3 w-3" />
            Course Catalog
          </span>
          <h1 className="text-4xl font-bold leading-tight text-foreground sm:text-5xl lg:text-6xl">
            Discover Your {" "}
            <span className="bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
              Next Steps
            </span>
          </h1>
          <p className="max-w-3xl text-lg text-muted-foreground sm:text-xl">
            Explore discipleship, onboarding, and ministry training courses designed for every congregant and volunteer. Start your journey today.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="container space-y-8">
          {hasCourses ? (
            <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
              {courses.map((course) => (
                <CourseCard key={course.id} course={course} />
              ))}
            </div>
          ) : (
            <div className="relative overflow-hidden rounded-2xl border border-dashed border-primary/30 bg-gradient-to-br from-primary/5 to-background p-16 text-center">
              <div className="mx-auto mb-4 inline-flex rounded-full bg-primary/10 p-4">
                <BookOpen className="h-8 w-8 text-primary" />
              </div>
              <p className="text-lg font-medium text-foreground">No courses available just yet</p>
              <p className="mt-2 text-muted-foreground">Check back soon as we publish new pathways.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
